"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useWhen = void 0;
var _react = require("react");
var useWhen = function useWhen() {
  for (var _len = arguments.length, params = new Array(_len), _key = 0; _key < _len; _key++) {
    params[_key] = arguments[_key];
  }
  var effect = params.pop();
  var deps = params;
  (0, _react.useEffect)(function () {
    if (deps.every(function (dep) {
      return !!dep;
    })) {
      return effect.apply(void 0, deps);
    }
  }, deps);
};
exports.useWhen = useWhen;